<div class="flex gap-3 items-center">
  <mot-button (onClick)="decreaseValue()" icon="minus" type="icon"
    [ariaLabel]="decreaseAriaLabel"
    buttonClass="!border !border-gray-300 !w-8 !border-solid !rounded-md" [disabled]="formControl.disabled" />

  <div class="flex-1 slider-wrapper px-6">
    <div dir="rtl">
      <mat-slider [class]="class" [max]="max" [min]="min" [step]="step" [discrete]="thumbLabel"
        [showTickMarks]="showTicks" [disableRipple]="true">
        <input matSliderThumb [class]="inputClass" [ngClass]="{'!left-0': direction == 'rtl', '!right-0': direction == 'ltr'}"
          [formControl]="formControl"
          [attr.aria-label]="label || null" />
      </mat-slider>
    </div>
    <div class="flex justify-between">
      <span>0</span>
      <span>{{max}}</span>
    </div>
  </div>
  <mot-button (onClick)="increaseValue()" icon="plus" type="icon"
    [ariaLabel]="increaseAriaLabel"
    buttonClass="!border !border-gray-300 !w-8 !border-solid !rounded-md" [disabled]="formControl.disabled" />

</div>
